var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"menu-close","transform":"translate(1.000000, 1.000000)","stroke":"#000000","strokeWidth":"2"},React.createElement("path",{"d":"M0,0 L17,17 M17,0 L0,17"}))));
}

MenuClose.defaultProps = {"viewBox":"0 0 19 19","version":"1.1"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
